import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const StepSectionForHome = () => {
  const [steps, setSteps] = useState([]);

    const [page, setPage] = useState([]);
    const { pageSlug } = useParams(); // Extract the blog post titleSlug from the URL
  
    useEffect(() => {
      fetch(`https://healthkeywordresearch01-5ec078e699df.herokuapp.com/page/${pageSlug}`)
        .then((res) => res.json())
        .then((info) => setPage(info))
        .catch((error) => console.error("Error fetching banners:", error));
    }, []);
  useEffect(() => {
    fetch(`https://healthkeywordresearch01-5ec078e699df.herokuapp.com/worksec`)
      .then((res) => res.json())
      .then((info) => setSteps(info));
  }, []);

  return (
   

    <><section
      id="process-3"
      className="process-3 bg-lightgrey wide-60 process-section division"
    >
      <div className="container">
        {/* SECTION TITLE */}
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <div className="section-title mb-60 text-center">
              {/* Title 	*/}
              <h3 className="h3-md">Simple 4-Step Process</h3>
              {/* Text */}

            </div>
          </div>
        </div>
        {/* PROCESS-3 WRAPPER */}
        <div className="pbox-3-wrapper text-center">
          <div className="row">

          {
            steps.map(a=> a.pageSlug === '' &&  <div className="col-sm-6 col-lg-3">
              <div className="pbox-3 " >
                {/* Step */}
                <div className="step bg-primary-color white-color">
                  <span>{a.stepTitle}</span>
                </div>
                {/* Icon */}
                <div className="pbox-3-ico ico-75 primary-color">
                  <img src={a.stepNumber} alt="Server Icon" className="icon-class" />
                </div>

                {/* Text */}
                <p className="grey-color">
                  {a.stepDetails}
                </p>
              </div>
            </div>
         )
          }
          
           
            
       
           
          </div>{" "}
          {/* End row */}
        </div>{" "}
        {/* END PROCESS-3 WRAPPER */}
        {/* PROCESS BUTTON */}
        <div className="row">
          <div className="col-md-12">
            <div
              className="process-btn text-center wow fadeInUp"
              data-wow-delay="1s"
            >
              <h5 className="h5-xs"></h5>
              <p className="grey-color"></p>

            </div>
          </div>
        </div>
      </div>{" "}
      {/* End container */}
    </section>
    </>
  );
};

export default StepSectionForHome;
